import React from "react";
import { Box, CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Navbar } from "./Components/Navbar";
import { CtaSection } from "./Components/CtaSection";
import { Footer } from "./Components/Footer";
import { HeroSection } from "./Components/HeroSection";
import { FeaturesSection } from "./Components/FeaturesSection";

// Tema personalizado com cores modernas
const theme = createTheme({
  palette: {
    primary: {
      main: "#2563EB", // Tom de azul moderno
      dark: "#1E40AF",
      light: "#60A5FA",
    },
    secondary: {
      main: "#10B981", // Verde esmeralda
      dark: "#059669",
      light: "#34D399",
    },
    background: {
      default: "#F9FAFB",
      paper: "#FFFFFF",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 600,
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
});

export const LandingPages0002 = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: "#F9FAFB",
        }}
      >
        <CssBaseline />
        <Navbar
          specialistName="Maria Saúde"
          specialistTitle="Consultora de Planos de Saúde"
          avatarSrc="https://via.placeholder.com/40"
        />
        <HeroSection />
        <FeaturesSection />
        <CtaSection />
        <Footer />
      </Box>
    </ThemeProvider>
  );
};
